// extracted by mini-css-extract-plugin
module.exports = {"list":"Mobile_list__mpHUh"};